import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import TargetConditionInput from 'components/CampaignWizards/TargetingInputArea/TargetConditionInput'
import { getChanges } from 'components/Customize/OrgSettings/Helpers'
import { Audiences } from 'components/Customize/Audience/Helpers'
import { NotificationMessages } from 'components/Customize/Availability/Constants'

import style from './style.styl'

function maybeUnsetUserListIds(orgSettings) {
  const { userListIds, audience } = orgSettings.theme

  if (userListIds && audience !== Audiences.SEGMENT.key) {
    return orgSettings.removeIn(['theme', 'userListIds'])
  }
  return orgSettings
}

class Target extends Component {

  static contextTypes = {
    app: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.onTargetIdSelected = this.onTargetIdSelected.bind(this)
  }

  updateOrgSettingsWithTargetId(targetId) {
    const { orgSettings } = this.props
    return orgSettings.setIn(['theme', 'targetId'], targetId)
  }

  onTargetIdSelected(newTargetId, targetEdited) {
    const initialTargetId = this.props.orgSettings.theme.targetId
    const shouldUpdate = targetEdited || (newTargetId !== initialTargetId)

    if (shouldUpdate) this.updateTargetId(newTargetId)
  }

  updateTargetId(targetId) {
    const initialOrgSettings = this.props.embed.configuration
    const updatedOrgSettings = this.updateOrgSettingsWithTargetId(targetId)
    const changes = getChanges(maybeUnsetUserListIds(updatedOrgSettings), initialOrgSettings)
    const { actions } = this.context.app

    actions.OrgSettingsActions.updateOrgSettings(updatedOrgSettings)
    actions.DefaultEmbedActions.patchDefaultEmbed(changes, NotificationMessages.TARGETING)
  }

  render() {
    const { orgSettings } = this.props

    return (
      <TargetConditionInput
        selectedTargetId={orgSettings.theme.targetId}
        onSelection={this.onTargetIdSelected}
        filterPlaybookTargets={true}
        className={style.ChatWidgetTargetRule} />
    )
  }
}

function mapStateToProps(state) {
  return {
    embed: state.get('embed').toJS().data,
  }
}

export default connect(mapStateToProps, null)(Target)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/HoursAndTargeting/Target/index.js